import React, { useEffect, useMemo } from 'react';

import classNames from 'classnames';

import useMenuPosition from '@/hooks/useMenuPosition';
import useScrollPosition from '@/hooks/useScrollPosition';

import { SideMenuLinks } from './SideMenuLinks';

import './SideMenu.scss';

export interface ListItemType {
  sectionId: string;
  title: string;
}

interface Props {
  items: ListItemType[];
  title: string;
  contextRef: React.RefObject<HTMLElement>;
}

export const Sidemenu = ({ items, title, contextRef }: Props) => {
  const menuRef = React.createRef<HTMLDivElement>();

  const { setElement, isInterceptedAtTop, progress } = useScrollPosition();
  const { isMenuFitsContainer } = useMenuPosition({ menuRef, contextRef });

  useEffect(() => {
    if (contextRef.current) {
      setElement(contextRef.current);
    }
  }, [contextRef, setElement]);

  const className = useMemo(
    () =>
      classNames('SideMenu', {
        SideMenu_fixed: isInterceptedAtTop,
        SideMenu_static: !isInterceptedAtTop,
        SideMenu_absolute: isMenuFitsContainer,
      }),
    [isInterceptedAtTop, isMenuFitsContainer],
  );

  return (
    <div ref={menuRef} className={className}>
      <p className="body-2 SideMenu_title">{title}</p>
      <div className="SideMenu_progress-bar-container">
      <div className="SideMenu_progress-bar" style={{ width: `${Math.max(0, progress)}%` }} />
      </div>
      <div className="SideMenu_links-container">
        <SideMenuLinks items={items} />
      </div>
    </div>
  );
};
